<template>
    <form autocomplete="off">
        <div class="grid md:grid-cols-2 gap-3">
            <k-input
                class="mb-4"
                id="firstName"
                label="First name"
                v-model="form.firstName"
                :field-errors="validation.fieldErrors"/>
            <k-input
                class="mb-4"
                id="lastName"
                label="Last name"
                v-model="form.lastName"
                :field-errors="validation.fieldErrors"/>
        </div>
        <k-input
            class="mb-4"
            id="companyName"
            label="Company Name"
            v-model="form.companyName"
            :field-errors="validation.companyName"/>
        <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="phone">
                Mobile phone
            </label>
            <vue-tel-input v-model="form.phone"
                           :validCharactersOnly="true"
                           inputClasses="appearance-none block w-full bg-gray-200 border-gray-200 text-gray-700 border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           :enabledCountryCode="false"
                           inputId="phone"
                           mode="international"
                           :preferredCountries="['SG']"
                           placeholder=""
                           :wrapperClasses="['appearance-none block w-full bg-gray-200 text-gray-700 border rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500', fieldError('phone') ? 'border-red-500!': 'border-gray-200']">

            </vue-tel-input>
            <div v-if="fieldError('phone')"
                 class="text-red-500 text-xs italic">
                {{ fieldError('phone') }}
            </div>
        </div>

        <k-input
            class="mb-4"
            id="email"
            label="Email"
            v-model="form.email"
            :field-errors="validation.fieldErrors"
            type="email"/>

        <k-select
            class="mb-4"
            id="type"
            label="Register as"
            v-model="form.type"
            :options="types"
            value-key="value"
            label-key="label"
            :field-errors="validation.fieldErrors"/>

        <div class="mt-6">
            <k-button @click.native.prevent="onSubmit">
                {{ $t("submit") }}
            </k-button>
        </div>
    </form>
</template>

<script>

import { VueTelInput } from 'vue-tel-input';

export default {
    components: {
        VueTelInput,
    },
    data() {
        return {
            loading: false,
            form: {},
            types: [
                {
                    label: 'Investor',
                    value: 'INVESTOR'
                },
                {
                    label: 'Borrower',
                    value: 'BORROWER'
                }
            ],
            validation: {
                fieldErrors: {}
            }
        };
    },
    async mounted() {
        if (this.$authToken()) {
            await this.$fetchInvestorProfile();
            await this.$routeInvestor();
        }
        if (!this.$isProd) {
            try {
                const { data } = await this.$http.get('/api/investor/public/fake-lead-sign-up', {});
                this.form = data;
            } catch (e) {
                console.error(e);
            }
        }

        this.form.email = this.$route.query.email;
        if (this.$route.query.type) {
            this.form.type = this.$route.query.type;
        } else {
            this.form.type = 'INVESTOR';
        }

    },
    methods: {
        async onSubmit() {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('public/lead-sign-up', this.form);
                await this.$router.push('/lead-registration-success');
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                    this.$scrollToErrorField();
                }
            }
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
    }
};
</script>

<style>
.vue-tel-input {
    border: unset !important;
}
</style>

